import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { apiKey } from "../config/config";

const DonutChartGroup = ({ lang }) => {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin
  ).branch_id;

  const [data, setData] = useState({
    total_customers: 0,
    total_investors: 0,
    total_contracts: 0,
  });

  const [loading, setLoading] = useState(true);

  // ✅ Fetch data from your backend API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${apiKey}/get-totals`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            branch_id: branchId,
          },
        });
        setData(data.result || {});
      } catch (error) {
        console.error("Error fetching dashboard totals:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [branchId, token]);

  // ✅ Chart options template (show numbers instead of %)
  const createOptions = (label, value) => ({
    chart: { type: "donut" },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: { show: false },
            value: {
              show: true,
              fontSize: "16px",
              fontWeight: 600,
              formatter: () => `${value}`, // show count here
            },
            total: {
              show: true,
              label: `${value}`,
              formatter: () => `${value}`,
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    colors: ["#1E90FF", "#E5E7EB"],
    stroke: { width: 0 },
  });

  if (loading) {
    return (
      <div className="text-center py-4">
        <p>Loading charts...</p>
      </div>
    );
  }

  return (
    <div className="row text-center mb-4 shadow-sm p-4 mb-4 ms-1 me-2 bg-light">
      {[
        { label: lang.Investors || "Investors", value: data.total_investors },
        { label: lang.Customers || "Customers", value: data.total_customers },
        { label: lang.Contracts || "Contracts", value: data.total_contracts },
      ].map((item, index) => (
        <div
          key={index}
          className="col-12 col-md-4 mb-3 d-flex flex-column align-items-center"
        >
          <Chart
            options={createOptions(item.label, item.value)}
            series={[item.value, 0]} // only to render donut shape
            type="donut"
            width={150}
          />
          <p className="mt-2 fw-medium">{lang.Total || "Total"} {item.label}</p>
        </div>
      ))}
    </div>
  );
};

export default DonutChartGroup;
